import { getLinkElement } from "../utils/get-link-element";
import { getTextElement } from "../utils/get-text-element";

/**
 * Highlights text or link elements when hovered over.
 * @param event The mouse event triggering the function.
 */
export function textHighlight(event: Event): void {
  // Get the element currently under the mouse pointer
  const hoveredElement = event.composedPath()[0] as HTMLElement;

  // Retrieve text and link elements from the hovered element
  const textElement = getTextElement(hoveredElement);
  const linkElement = getLinkElement(hoveredElement);

  if (textElement && (isValidElement(textElement) || linkElement)) {
    const oldElement = (window as any).VLibras.__oldElement;

    if (oldElement !== textElement && textElement instanceof HTMLElement) {
      if (oldElement) {
        oldElement.style.cssText = null;
      }

      (window as any).VLibras.__oldElement = textElement;
      const originalStyle = textElement.style.cssText;

      textElement.style.cssText += `
        opacity: 1 !important;
        cursor: url("data:image/png;base64,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"), pointer !important;
        text-decoration: underline !important;`;

      // Add mouseout event listener to insert the original style when the mouse leaves the element
      textElement.addEventListener("mouseout", () => {
        textElement.style.cssText = originalStyle;
        (window as any).VLibras.__oldElement = null;
      });
    }
  }

  if (
    linkElement instanceof HTMLElement &&
    linkElement &&
    isValidElement(linkElement) &&
    linkElement !== textElement
  ) {
    const oldLinkElement = (window as any).VLibras.__oldLinkElement;

    if (oldLinkElement !== linkElement) {
      if (oldLinkElement) {
        oldLinkElement.style.cssText = null;
      }

      (window as any).VLibras.__oldLinkElement = linkElement;
      const originalStyle = linkElement.style.cssText;

      linkElement.style.cssText += `
    opacity: 1 !important;
    cursor: url("data:image/png;base64,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"), pointer !important;
    text-decoration: underline !important;      `;

      linkElement.addEventListener("mouseout", () => {
        linkElement.style.cssText = originalStyle;
        (window as any).VLibras.__oldLinkElement = null;
      });
    }
  }
}

export function isValidElement(element: Element) {
  if (
    document.querySelector("[vp]")?.closest("[vw]")?.contains(element) ||
    document.querySelector(".vp-guide-container")?.contains(element)
  )
    return false;
  return element.matches(".vw-links")
    ? false
    : hasTextContent(element) ||
        hasLinkAncestor(element) ||
        isSubmitInput(element) ||
        isValidImage(element) ||
        isSelect(element) ||
        isSVG(element) ||
        isIcon(element);
}

const hasTag = (el: Element, tags: string[] | string) =>
  tags.includes(el.tagName?.toUpperCase());

const isLinkOrButton = (el: Element) => hasTag(el, ["A", "BUTTON"]);

const isSubmitInput = (el: Element) =>
  hasTag(el, "INPUT") && (el as HTMLInputElement)?.type === "submit";

const isValidImage = (el: Element) =>
  hasTag(el, "IMG") && (el as HTMLImageElement)?.alt?.trim();

const isSelect = (el: Element) => hasTag(el, "SELECT");

const isSVG = (el: Element) => hasTag(el, ["SVG", "PATH"]);

const isIcon = (el: Element) => hasTag(el, "SY-ICON");

function hasTextContent(element: Element): boolean {
  const check = (item: Element) =>
    item.nodeType === Node.TEXT_NODE && item.textContent?.trim();

  return Array.from(element.childNodes).some((e) => e && check(e as Element));
}
function hasLinkAncestor(el: Element) {
  const $root = Array.from([document.body, ...document.body.children]);

  while (el) {
    if ($root.includes(el)) break;
    if (
      isLinkOrButton(el) ||
      (el instanceof HTMLElement && el.onclick && !isSVG(el))
    )
      return el;

    el = el.parentNode as Element;
  }
  return null;
}

function checkPath(parent: Element, children: Element | null) {
  if (!children) return;

  if (parent === children) return true;

  return checkPath(
    parent,
    (children.parentElement as Element) ||
      children.parentNode ||
      (children as any).host
  );
}
